export default "__VITE_ASSET__9b77eab3__"